import { useSuspenseNetworkQuery } from '#api/networks.queries.ts';

type Props = {
  networkId: string;
};

/** Requests details about a network ID, and returns the name */
export function NetworkName({ networkId }: Props) {
  const network = useSuspenseNetworkQuery(networkId).data.data;
  return network.name;
}
